// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3bM2B","file":"styles_file__2Kqxe"};